import React, { Component} from 'react';

import Select from './../Select';

const data = [
    {value: '1', label: "字典分类"},
    {value: '2', label: "字典值"}
];

const CodeType = (props) => (
    <Select name="codeType" label="字典类型" data={data} {...props} ></Select>
);

export default CodeType;